import { AbstractCommand } from 'src/models/command';

class AppHasMovedToTheForegroundCommand extends AbstractCommand {
	readonly name = 'IFS_App_Command_Commands_AppHasMovedToTheForeground';

	public constructor(platform: string, browser: string, version: string) {
		super();

		this.parameters = {
			browser: browser,
			platform: platform,
			version: version,
		};
	}
}

export { AppHasMovedToTheForegroundCommand };
